import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

import ScrollClass from './../../../../../../../../js/classes/Scroll.js'

import ManagerOrders from './../../../../../../../../js/classes/ManagerOrders.js'

import Loading from './../Loading.jsx'

import './../css/list.scss'
import ListItem from './ListItem.jsx'

const OrdersList = ({  }) => {
    const [data, setData] = useState([]),
    [isLoading, setLoading] = useState(false)

    const refetch = (cb, page=1) => {
        setLoading(true)

        ManagerOrders.getList((err, res) => {
            console.log(err, res)

            if (err) {
                console.log(err)
            } else {
                res.properties.forEach((propertyGroup) => {
                    if (propertyGroup.PROPERTIES && propertyGroup.PROPERTIES.length > 0) {
                        propertyGroup._PROPERTIES = propertyGroup.PROPERTIES.reduce((r, el) => {
                            r[el.CODE] = el

                            return r
                        }, {})
                    } else {
                        propertyGroup._PROPERTIES = []
                    }
                })

                console.log(res)

                setData(res)

                setTimeout(() => {
                    document.querySelectorAll('.manager__pagination .main-ui-pagination-page').forEach((pageNode) => {
                        pageNode.addEventListener('click', (e) => {
                            e.preventDefault()

                            if (pageNode.hasAttribute('href')) {
                                const nPage = parseInt(pageNode.getAttribute('href'))

                                ScrollClass.scrollTo('.manager')

                                refetch(null, nPage || 1)
                            }

                            return false
                        })
                    })
                }, 0)
            }

            setLoading(false)

            if (cb) cb(err, res)
        }, page, 10)
    }

    useEffect(() => {
        refetch()
    }, [])
    
    return <div className="manager manager_orders">
        <div className="manager__inner">
            <h1 className="manager__h1">Список заказов</h1>

            { isLoading ? <Loading /> : (data.orders && data.orders.length > 0) ? <>
                <div className="manager__list">
                    <div className="manager__table">
                        <div className="manager__header">
                            <div className="manager__row">
                                <div className="manager__th manager__th_number-date">
                                    Номер заказа<br />Дата
                                </div>
                                <div className="manager__th">
                                    Покупатель
                                </div>
                                <div className="manager__th">
                                    Оплата
                                </div>
                                <div className="manager__th">
                                    Доставка
                                </div>
                                <div className="manager__th">
                                    Состав заказа
                                </div>
                                <div className="manager__th">
                                    Сумма заказа
                                </div>
                                <div className="manager__th">
                                    Статус
                                </div>
                            </div>
                        </div>
                        <div className="manager__body">
                            { data.orders.map((order) => {
                                return <ListItem key={ `manager-order-${ order.ID }` } order={ order } data={ data } />
                            }) }
                        </div>
                    </div>
                </div>

                { data.pagination ? <div className="manager__pagination" dangerouslySetInnerHTML={ { __html : data.pagination } } /> : null }
            </> : <div className="manager__list-empty">
                — Пусто —
            </div> }
        </div>
    </div>
}

export default OrdersList